<template>
  <div>
    <!--  -->
    <B1 />

    <B2 />
  </div>
</template>

<script>
import B1 from "./components/b1.vue";
import B2 from "./components/b2.vue";

export default {
  components: {
    B1,
    B2,
  },
};
</script>

<style>
</style>